import { type ExcalidrawFontFaceDescriptor } from "../Fonts";

import NotoNaskhArabicRegular from "./NotoNaskhArabic-Regular.woff2";

/**
 * KHIYARSA PATCH (see PATCHES.khiyarsa.md): Arabic script fallback font.
 *
 * Noto Naskh Arabic Regular (SIL Open Font License 1.1), Google Fonts
 * "arabic" subset (v44, font version 2.021). Registered as a fallback
 * family — analogous to the Xiaolai CJK fallback — so Arabic glyphs render
 * with proper Naskh shaping regardless of the user's selected font family.
 *
 * The unicode-range below is Google Fonts' "arabic" subset range: Arabic,
 * Arabic Supplement, Arabic Extended-A/B, presentation forms, Rumi/ancient
 * numerals and Arabic mathematical alphabetic symbols, plus the RTL/ZWJ
 * format controls (U+200C-200E) needed for correct joining behavior.
 */
export const NotoNaskhArabicFontFaces: ExcalidrawFontFaceDescriptor[] = [
  {
    uri: NotoNaskhArabicRegular,
    descriptors: {
      unicodeRange:
        "U+0600-06FF, U+0750-077F, U+0870-088E, U+0890-0891, U+0897-08E1, U+08E3-08FF, U+200C-200E, U+2010-2011, U+204F, U+2E41, U+FB50-FDFF, U+FE70-FE74, U+FE76-FEFC, U+102E0-102FB, U+10E60-10E7E, U+10EC2-10EC4, U+10EFC-10EFF, U+1EE00-1EE03, U+1EE05-1EE1F, U+1EE21-1EE22, U+1EE24, U+1EE27, U+1EE29-1EE32, U+1EE34-1EE37, U+1EE39, U+1EE3B, U+1EE42, U+1EE47, U+1EE49, U+1EE4B, U+1EE4D-1EE4F, U+1EE51-1EE52, U+1EE54, U+1EE57, U+1EE59, U+1EE5B, U+1EE5D, U+1EE5F, U+1EE61-1EE62, U+1EE64, U+1EE67-1EE6A, U+1EE6C-1EE72, U+1EE74-1EE77, U+1EE79-1EE7C, U+1EE7E, U+1EE80-1EE89, U+1EE8B-1EE9B, U+1EEA1-1EEA3, U+1EEA5-1EEA9, U+1EEAB-1EEBB, U+1EEF0-1EEF1",
    },
  },
];
